export default __webpack_public_path__ + "static/media/GF_POSTER_GROUP_04.c1347a19.jpg";